import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

interface ErrorFallbackProps {
  errorId?: string;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ errorId }) => {
  const { t } = useTranslation();

  const handleGoBack = () => {
    window.history.back();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>{t("Something went wrong")}</h1>
        <p className={styles.message}>
          {t("An unexpected error occurred. Please try refreshing the page.")}
        </p>

        {errorId && (
          <div className={styles.errorIdContainer}>
            <p className={styles.errorIdLabel}>{t("Error ID")}:&nbsp;</p>
            <code className={styles.errorIdCode}>{errorId}</code>
            <p className={styles.errorIdHelp}>
              {t("Please share this ID with support if you report this issue.")}
            </p>
          </div>
        )}

        <button onClick={handleGoBack} className={styles.button}>
          {t("Go Back")}
        </button>
      </div>
    </div>
  );
};
